import React from 'react';
import { motion,easeInOut, } from 'framer-motion';
import { Search, Loader2 } from 'lucide-react';

export const LoadingCard: React.FC = ({message}:any) => {
  const spinVariants = {
    spin: {
      rotate: 360,
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: easeInOut,
      }
    }
  };

  const pulseVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: easeInOut,
      }
    }
  };

  const dotVariants = {
    animate: {
      scale: [1, 1.2, 1],
      transition: {
        duration: 0.6,
        repeat: Infinity,
        ease: easeInOut,
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-md mx-auto"
    >
      <motion.div
        variants={pulseVariants}
        animate="pulse"
        className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-8 shadow-2xl text-center"
      >
        <div className="flex items-center justify-center mb-6">
          <div className="relative">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-indigo-600 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-white" />
            </div>
            <motion.div
              variants={spinVariants}
              animate="spin"
              className="absolute -top-2 -right-2 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center"
            >
              <Loader2 className="w-5 h-5 text-white" />
            </motion.div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          {message || "Searching for User"}
        </h2>

        <p className="text-gray-600 mb-6">
          Please wait while we look up the user information...
        </p>

        <div className="flex items-center justify-center space-x-2">
          <motion.div
            variants={dotVariants}
            animate="animate"
            className="w-3 h-3 bg-blue-500 rounded-full"
          />
          <motion.div
            variants={dotVariants}
            animate="animate"
            transition={{ delay: 0.2 }}
            className="w-3 h-3 bg-blue-500 rounded-full"
          />
          <motion.div
            variants={dotVariants}
            animate="animate"
            transition={{ delay: 0.4 }}
            className="w-3 h-3 bg-blue-500 rounded-full"
          />
        </div>

        <div className="mt-6 text-sm text-gray-500">
          This may take a few moments
        </div>
      </motion.div>
    </motion.div>
  );
};